import styled from '@emotion/styled';

import { Breakpoints } from 'utils/const.styles';

export const ProductBoxDimensions = styled.div`
	display: flex;
	align-items: center;
	> div {
		padding: 0;
		padding-right: 1rem;
		:last-of-type {
			padding-right: 0;
		}
		body[dir='rtl'] & {
			padding-right: unset;
			padding-left: 1rem;
			:last-of-type {
				padding-left: 0;
			}
		}
	}
`;

export const TabContainer = styled.div`
	display: flex;
	flex-wrap: wrap;
	width: 100%;
	margin: var(--margin-2) 0;
	@media ${Breakpoints.mobile} {
		display: none;
	}
`;
